import { useState } from "react";

export const isServer = typeof window == "undefined";
const isCustomization = getEnvVar("PUBLIC_PROJECT") === "customization";

export function getEnvVar(key: string, returnKeyOnUndefined = true) {
  if (isServer) {
    return process.env[key] || (returnKeyOnUndefined ? key : undefined);
  }
  return window.ENV[key] || (returnKeyOnUndefined ? key : undefined);
}

export const getApiUrl = (isSsr = false) =>
  isSsr
    ? getEnvVar("PUBLIC_BACKEND_INTERNAL")
    : getEnvVar("PUBLIC_BACKEND_HOST");

export const getAssetsUrl = () => {
  // Si existe PUBLIC_ASSETS_URL, usarlo directamente
  const assetsUrl = getEnvVar("PUBLIC_ASSETS_URL", false);
  if (assetsUrl && assetsUrl !== "PUBLIC_ASSETS_URL") {
    return assetsUrl;
  }
  
  // Verificar PUBLIC_ENV (sin usar el valor por defecto)
  const env = getEnvVar("PUBLIC_ENV", false);
  const isProd = env === "prod";
  
  // Si no está configurado PUBLIC_ENV, intentar detectar por el dominio
  if (!isProd && env === "PUBLIC_ENV") {
    const host = getEnvVar("PUBLIC_HOST", false);
    // Si el host no contiene "dev", asumir que es producción
    if (host && host !== "PUBLIC_HOST" && !host.includes("dev")) {
      return `/prod`;
    }
  }
  
  // En producción, usar /prod
  if (isProd) {
    return `/prod`;
  }
  
  // En desarrollo, usar URL absoluta con /dev
  const host = getEnvVar("PUBLIC_HOST", false);
  if (host && host !== "PUBLIC_HOST") {
    return `${host}/dev`;
  }
  
  // Fallback: usar /dev si no hay host configurado
  return `/dev`;
};

export const getServerCountry = () => {
  return getEnvVar("PUBLIC_COUNTRY");
};

export const getDomain = () => {
  return getEnvVar("PUBLIC_HOST");
};

export function useSessionStorage<T>(key: string, initialValue?: T) {
  const [state, setState] = useState<T | undefined>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value?: T | ((val?: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(state) : value;
      setState(valueToStore);
      if (typeof window !== "undefined") {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return [state, setValue] as const;
}

export const isSafari = () =>
  navigator.userAgent.indexOf("Safari") > -1 &&
  !(navigator.userAgent.indexOf("Chrome") > -1);

export const checkIfIsisMobile = (userAgent: string) => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return userAgent.match(toMatchItem);
  });
};
